import tokenImageY from "../assets/img/Token_yes.webp";

const TokenImageNAUY: React.FC = () => {
  const handleClick = () => {
    window.open(
      "https://basescan.org/token/0x8fE351FD35DDC08bc2f3c5fA573B44d6E13f97ec",
      "_blank"
    );
  };

  return (
    <img
      src={tokenImageY}
      alt="NAUY Token"
      onClick={handleClick}
      className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-full shadow-md hover:shadow-xl hover:scale-105 transition duration-300 ease-in-out"
    />
  );
};

export default TokenImageNAUY;
